import { graphql } from "react-relay";

export const ORDER_FRAGMENT = graphql`
	fragment closeOrderAction_OrderFragment on Order {
		id
		status
	}
`;

export const CLOSE_ORDER_MUTATION = graphql`
	mutation closeOrderAction_CloseOrderMutation($input: CloseOrderInput!) {
		Admin {
			Billing {
				closeOrder(input: $input) {
					order {
						id
						status
						history {
							...orderHistoryTable_OrderHistoryFragment
						}
					}
					clientMutationId
				}
			}
		}
	}
`;
